import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { HisTreeSelectComponent } from '../../tree/component/his-tree-select.component';
import { HisTreeSelectWidget } from '../model/his-widget-tree-select';

@Component( {
    selector: 'his-search-tree-select',
    templateUrl: './his-search-tree-select.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisSearchTreeSelectComponent extends HisTreeSelectComponent {

    // widget is only passed to let the plam extract attributes like helptext from the search config file;
    // it will be undefined when the component is used standalone, outside the generic search.
    @Input() widget: HisTreeSelectWidget;

    @Input() showUnequalOption: boolean;

    // true if this is the first input element in the search mask
    @Input() isFirstInputElement = false;

    constructor() {
        super();
    }
}
